var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileLightBlueWhiteBgShortRoundedLightBlueBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    stroke: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12 10.8954 12.8954 10 14 10H24.9454C25.4617 10 25.958 10.1997 26.3304 10.5572L31.3851 15.4097C31.7779 15.7868 32 16.3078 32 16.8524V32C32 33.1046 31.1046 34 30 34H14C12.8954 34 12 33.1046 12 32V12Z",
    stroke: "#5062F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 11.1992V15.1992C24.5 16.3038 25.3954 17.1992 26.5 17.1992H28.25H30.75",
    stroke: "#5062F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.1992H19.5",
    stroke: "#5062F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22L27 22",
    stroke: "#5062F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.8008L27 26.8008",
    stroke: "#5062F0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLightBlueWhiteBgShortRoundedLightBlueBorder);
export default __webpack_public_path__ + "static/media/fileLightBlueWhiteBgShortRoundedLightBlueBorder.223ca0dbe450ee34ffda83e536e57ae3.svg";
export { ForwardRef as ReactComponent };